import { useBaseInfoStore } from '@/pages/clusters/pages/Workload/create/base-info';
import { create } from 'zustand';
import { useAddMetadataStore } from '../add-metadata';
import { useContainerStore } from '../container';
import { useSecurityContextStore } from '../container-security-context';
import { useDockerSettingStore } from '../docker-setting';
import { useEnvironmentVarStore } from '../environment-variable';
import { useHealthCheckStore } from '../health-check';
import { useImageOptionsStore } from '../image-options';
import { useLifecycleManageStore } from '../lifecycle-manage';
import { useNodesAndMetadataStore } from '../nodes-and-metadate/useNodesAndMetadataStore';
import { usePodNumsStore } from '../pod-nums/usePodNumsStore';
import { usePodSchedulingRulesStore } from '../pod-scheduling-rules/usePodSchedulingRulesStore';
import { usePodSecurityContextStore } from '../pod-security-context';
import { usePortSettingStore } from '../port-setting';
import { useStartupCmdStore } from '../startup-cmd';
import { useStorageSettingStore } from '../storage-settings';
import { useSyncHostTimezoneStore } from '../sync-host-timezone';
import { WorkloadType } from '../types';
import { useUpdateStrategyStore } from '../update-strategy';
import { useHeadlessServiceYamlStore } from './useHeadlessServiceYamlStore';

interface UseResetWorkloadProps {
  /** 添加容器 modal 关闭重置添加容器 modal 相关的状态 */
  resetContainerModal: (module?: WorkloadType) => void;
  /** 重置所有步骤的状态 */
  resetAll: (module?: WorkloadType) => void;
}

const resetContainerModal = (module?: WorkloadType) => {
  /** 重置容器设置 */
  useDockerSettingStore.getState().reset();
  /** 重置端口设置 */
  usePortSettingStore.getState().reset();
  /** 重置镜像选项 */
  useImageOptionsStore.getState().reset();
  /** 重置健康检查 */
  useHealthCheckStore.getState().reset();
  /** 重置生命周期管理 */
  useLifecycleManageStore.getState().reset();
  /** 重置启动命令 */
  useStartupCmdStore.getState().reset();
  /** 重置环境变量 */
  useEnvironmentVarStore.getState().reset();
  /** 重置安全上下文 */
  useSecurityContextStore.getState().reset();
  /** 重置主机时区同步 */
  useSyncHostTimezoneStore.getState().reset();
};

const resetAllSteps = (module?: WorkloadType) => {
  /** 第一步 */
  useBaseInfoStore.getState().reset();
  /** 第二步 */
  usePodNumsStore.getState().reset();
  useContainerStore.getState().reset();
  useUpdateStrategyStore.getState().reset(module);
  usePodSecurityContextStore.getState().reset();
  usePodSchedulingRulesStore.getState().reset();
  useAddMetadataStore.getState().reset();
  /** 第三步 */
  useStorageSettingStore.getState().reset();
  /** 第四步 */
  useNodesAndMetadataStore.getState().reset();
  /** 无头服务 */
  useHeadlessServiceYamlStore.getState().reset();
};

const resetAll = () => {
  resetContainerModal();
  resetAllSteps();
};

export const useResetWorkload = create<UseResetWorkloadProps>()(() => {
  return {
    resetContainerModal,
    resetAll,
  };
});
